const caseManagementGoals =  {
  section: "CMG",
  topic: "Care Coordination Needs",
  checked: "true",
  // access: "public",
  color: "secondary",
  description: "(optional)",
  body: [
    // {
    //   id: "CMG.1",
    //   shortname: "cmg0",
    //   name: "Care Coordination Needs",
    //   prevalue: "",
    //   value: "",
    //   disabled: "false",
    //   type: "radio",
    //   radio_options: ["Yes", "No"],
    //   act: "CMG0",
    //   mandatory: "true",
    //   depending: "",
    //   exception: "",
    //   link: "CMG1",
    //   // subtopic_container_act: "CI1",
    //   // suptopic_code: "CI1_INFO3",
    //   // subtopic_name: "",
    // },
    {
      id: "CMG.1",
      // extend: "true",
      shortname: "cmg1",
      name: "Care Coordination Needs",
      prevalue: "",
      value: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      disabled: "false",
      type: "checkbox",
      radio_options: [
        "Vocational/Educational-Training & Opportunities",
        "Employment Resume /Coaching Services",
        "Budget -Credit Report - Finances",
        "Housing Assessment",
        "Housing /Transitional Housing",
        "Homeless Program Referrals",
        "Health-Medical wellness",
        "Social Network -12 step-Faith Base Support",
        "Public Benefits-Transportation",
        "Clothing/Food",
        "Legal Protections for People with Criminal Records",
      ],
      act: "CMG1",
      depending: "",
      exception: "",
      // depending: "CMG0",
      // exception: "Yes",
    },
  ]
}

export default caseManagementGoals;
